// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"344":"component---src-templates-salarie-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"344":"a025714dfe740763813a","678":"60ffb9da462c3718c6ab","883":"f98e1c5d1eecfbf433f4"}[chunkId] + ".js";
};